/* eslint-disable import/no-anonymous-default-export */
import React from "react";
import useAssessmentHeader from "./useAssessmentHeader";
import './AssessmentHeader.scss'

export default (props) => {
  const {
    viewDashboardClick,  
  } = useAssessmentHeader();
  return (
    <header className="assessment-header position-fixed bg-white border-bottom px-3 px-xl-5 w-100">
      <div className="header-wrapper d-flex w-100 justify-content-between align-items-center py-1">
        <div className="left mr-3 py-3">
          <button
            className="bg-transparent border-0 d-inline-block cursor-pointer"
            onClick={viewDashboardClick}
          >
            <img
              src="/assets/images/logo.svg"
              alt="logo"
              className="cursor-pointer"
            />
          </button>
        </div>
       
      </div>
    </header>
  );
};
